import styled from 'styled-components'

export const AnchorTextComponent = styled.p`
  color: ${ (props) => props.theme.colors['panel-inner-border'] };
  margin-bottom: 20px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }
`
